import { TrevorComponent } from '@trevor/ui-components';
import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
// @ts-expect-error: Update to the latest version - written in TS.
import cookie from 'react-cookie';
import { ToggleHint } from '@/features/publicDatasets/PublicDatasetProcessHints/subcomponents/ToggleHint';
import PublicDatasetHintsList from './subcomponents/PublicDatasetHintsList';

const HINT_CLOSED_COOKIES = 'public-dataset-learn-hint-closed';
const COOKIES_MAX_AGE = 60 * 60 * 24 * 31 * 12; /* 1 year */

const PublicDatasetProcessHints: TrevorComponent = ({ className }) => {
  const [minimized, setMinimized] = useState<boolean>(true);

  useEffect(() => {
    const hintClosed = cookie.load(HINT_CLOSED_COOKIES);
    if (hintClosed) {
      setMinimized(hintClosed === 'true');
    }
  }, []);

  useEffect(() => {
    cookie.save(HINT_CLOSED_COOKIES, minimized, {
      path: '/',
      maxAge: COOKIES_MAX_AGE,
    });
  }, [minimized]);

  return (
    <div className={className}>
      {!minimized && <PublicDatasetHintsList />}
      <ToggleHint toggle={setMinimized} isMinimized={minimized} />
    </div>
  );
};

export default styled(PublicDatasetProcessHints)`
  position: absolute;
  left: 16px;
  bottom: 16px;
`;
